export default __webpack_public_path__ + "static/media/Program-OT-Black.3b5ac17a.otf";